// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"4d3464f5","251":"4d769e3b","348":"654d7793","364":"e5706841","571":"fbf50c88"}[chunkId] + ".chunk.js";
};